import { render, staticRenderFns } from "./MyCalendarIndex.vue?vue&type=template&id=34b965dd&"
import script from "./MyCalendarIndex.vue?vue&type=script&lang=js&"
export * from "./MyCalendarIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports